import { useState, useMemo, ReactNode } from 'react';
import * as S from './Tabs.styles';
import { EuiTabs } from '@elastic/eui';

interface Tab {
  readonly id: string;
  readonly name: string;
  readonly href?: string;
  readonly content: ReactNode;
  readonly disabled?: boolean;
}

type Content = ReadonlyArray<Tab>;

export const Tabs = <A extends string>({ content, selectedId }: { content: Content; selectedId: A }): JSX.Element => {
  const [selectedTabId, setSelectedTabId] = useState<string>(selectedId);
  const selectedTabContent = useMemo(() => {
    return content.find((obj) => obj.id === selectedTabId)?.content;
  }, [content, selectedTabId]);

  const onSelectedTabChanged = (id: string): void => {
    setSelectedTabId(id);
  };

  const renderTabs = (): ReactNode =>
    content.map((tab, index) => (
      <S.Tab
        test-id={`tab-button-${tab.id}`}
        key={index}
        href={tab.href}
        onClick={(): void => {
          onSelectedTabChanged(tab.id);
        }}
        isSelected={tab.id === selectedTabId}
        disabled={tab.disabled}
      >
        {tab.name}
      </S.Tab>
    ));

  return (
    <S.TabsContainer>
      <EuiTabs>{renderTabs()}</EuiTabs>
      {selectedTabContent}
    </S.TabsContainer>
  );
};
